import { FC } from 'react';
import cn from 'classnames';

import s from './Button.module.css';

import { ButtonProps } from './Button.props';

import ArrowIcon from '@/public/icons/arrow.svg';

export const Button: FC<ButtonProps> = ({
  isWhite = false,
  withIcon = false,
  isTransparent = false,
  className,
  children,
  disabled = false,
  ...props
}) => {
  return (
    <button
      className={cn(
        'dark:border-accentAdditional dark:bg-accentAdditional dark:text-darkFullDark',
        'dark:hover:border-accentMain dark:hover:bg-accentMain dark:focus:border-accentMain dark:focus:bg-accentMain',
        'dark:active:border-accentAdditional dark:active:bg-accentMain dark:active:text-darkFullDark',
        s.btn,
        className,
        {
          [s.large]: withIcon,
          [s.white]: isWhite,
          [s.transparent]: isWhite && isTransparent,
        },
      )}
      disabled={disabled}
      {...props}
    >
      <>
        <span
          className={cn({
            'mr-2': withIcon,
          })}
        >
          {children}
        </span>
        {withIcon && <ArrowIcon className="aspect-square w-5" />}
      </>
    </button>
  );
};
